import { NavLink } from 'react-router-dom';
import './Chrome.scss'
import { useSecureApplication } from '../../hooks/KeycloackConnection';
import { useTranslation } from 'react-i18next';
import { MenuItemType, SideMenu } from '@kosmos/shared';
import { useAppSelector } from '../../hooks/hooks';
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { useNavigate } from "react-router-dom";

export function NavBar() {
    const {t} = useTranslation();
    const {hasAnyPerm} = useSecureApplication();

    const requireAuthRedirect = useSelector(
        (state: RootState) => state.app.requireAuthRedirect
      );

    const authParams = useSelector(
        (state: RootState) => state.app.authParams
      );
    const navigate = useNavigate();
    useEffect(() => {
        if(authParams) {
            if(authParams?.oauth2_auth_available) {
                navigate("/auth");
            } else {
                navigate("/basicauth");
            }
        }
    }, [requireAuthRedirect, authParams]);

    let menu: MenuItemType[] = [
        {
            label: 'Supervision',
            icon: 'pi pi-eye',
            link: <NavLink to="/dashboard">Supervision</NavLink>
        }
    ];

    if (hasAnyPerm('flows.all', 'flows_list')) {
        menu.push({
            label: 'Flux',
            icon: 'fas fa-forward',
            link: <NavLink to="/workflows">Flux</NavLink>
        });
    }

    if (hasAnyPerm('pipelines.all', 'pipelines.list')) {
        menu.push({
            label: 'Traitements',
            icon: 'pi pi-share-alt',
            link: <NavLink to="/treatments">Traitements</NavLink>
        });
    }

    const isCdsActive = useAppSelector(
        (state) => state.app.config.cds?.isActive
    );
    if(isCdsActive && hasAnyPerm('gds.read','gds.manage','gds.startpause')) {
        menu.push({
            label: t('title.data-catalog.sources'),
            icon: 'pi pi-arrow-circle-right',
            link: <NavLink to="/library/sources">{t('title.data-catalog.sources')}</NavLink>
        });
    }
    menu.push(
        {
            label: t('title.data-catalog.functions'),
            icon: 'pi pi-box',
            link: <NavLink to="/library/functions">{t('title.data-catalog.functions')}</NavLink>
        }
    );

    return <SideMenu menu={menu} width={'270px'} />
}
